<template>
  <div class="">
    <div
      class="mt-3 mb-0 d-flex justify-content-between align-items-center border-bottom mb-2 border-color-light-gray"
    >
      <div class="d-flex align-items-center">
        <div class="">
          <a
            v-if="hasCurrentUserReportPermission('Patients')"
            class="hover-pointer"
            style="font-size: 14px"
            @click="showReportRequestsModal = true"
          >
            <i class="fa fa-download"></i>
            <span class="ml-2 text-primary" style="font-size: 14px"
              >Export</span
            >
          </a>
        </div>
        <div
          v-if="
            currentUser &&
              !currentUser.onlyAccessAssignedPatients &&
              hasCurrentUserReportPermission('Patients')
          "
          class="border-left border-med-light-gray pl-1 ml-1 mr-1"
          style="width: 1px; height: 19px"
        ></div>
        <vue-toggles
          v-if="currentUser && !currentUser.onlyAccessAssignedPatients"
          @click="changeAssignedToMEToggle"
          :value="assignedToMe"
          height="20"
          width="30"
          checkedBg="#34C759"
          uncheckedBg="#FF6161"
        />
        <small
          v-if="currentUser && !currentUser.onlyAccessAssignedPatients"
          class="ml-2"
          >Show My Patients only</small
        >
      </div>
      <span>{{ listTotal }} matching results</span>
    </div>
    <div id="eoc-cards-container" class="d-flex flex-row flex-wrap">
      <div
        v-for="(eoc, eocIndex) in list"
        :key="eoc.id"
        class="client-card border rounded mr-3 mb-3 p-1 bg-white"
        @click="viewClientEOC(eoc)"
        :class="getStatusBorderClass(eoc.status)"
      >
        <div
          class="d-flex flex-row justify-content-between mb-3 position-relative"
        >
          <div
            :id="'eocIndexCardItem-status-value_' + eocIndex + '_' + eoc.status"
            class="little-circle rounded-circle"
            :class="getStatusBGClass(eoc.status)"
          ></div>
          <div
            class="d-flex flex-row-reverse flex-wrap align-items-start position-absolute"
            style="width: 159px; top:0px; right:0px;"
          >
            <div class="little-circle-exclamation-container">
              <i
                v-if="
                  eoc.notes &&
                    eoc.notes.filter(n => n.status == 'Enabled').length > 0
                "
                class="alert-note-icon fas fa-exclamation-circle text-danger"
                :id="'eocIndexCardItem-note-value' + eoc.id"
              ></i>
              <b-tooltip
                :target="'eocIndexCardItem-note-value' + eoc.id"
                triggers="hover"
                v-if="
                  eoc.notes &&
                    eoc.notes.filter(n => n.status == 'Enabled').length > 0
                "
                custom-class="text-left"
              >
                <div class="">
                  <div
                    v-for="note in eoc.notes.filter(n => n.status == 'Enabled')"
                    :key="note.id"
                    class="text-left position-relative m-1"
                  >
                    <div
                      class="position-absolute bg-white tooltip-icon-bg"
                    ></div>
                    <i
                      class="position-absolute alert-note-icon fas fa-exclamation-circle text-danger"
                      style="z-index:2;"
                    ></i>

                    <small
                      class="ml-4"
                      v-html-sanitize="formatAlert(note.content)"
                    ></small>
                  </div>
                </div>
              </b-tooltip>
            </div>
            <div
              v-for="badge in eoc.badges"
              :key="badge.id"
              class="badge text-white mr-1 mb-1"
              :style="{ backgroundColor: badge.category.color }"
            >
              <div :id="`badge-${badge.id}-eoc-${eoc.id}`">
                {{ badge.acronym }}
                <div
                  v-show="false"
                  :id="'eocIndexCardItem-badge-value_' + badge.acronym"
                >
                  {{ badge.acronym }}
                </div>
                <b-tooltip
                  :target="`badge-${badge.id}-eoc-${eoc.id}`"
                  triggers="hover"
                >
                  <small>{{ badge.name }}</small>
                </b-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-row justify-content-center">
          <div class="client-avatar rounded-circle picture-preview">
            <img
              v-if="
                eoc.status == 'Inactive' ||
                  (eoc.patient && !eoc.patient.avatarId)
              "
              :src="require(`../../assets/avatar-example.png`)"
            />
            <div
              v-else-if="
                eoc.status != 'Inactive' &&
                  eoc.patient &&
                  eoc.patient.avatarId &&
                  !patientAvatars[eoc.patient.avatarId]
              "
              class="w-100 h-100 d-flex justify-content-center align-items-center text-center"
            >
              <span class="color-custom-dark-grey">Loading image</span>
            </div>
            <img v-else :src="patientAvatars[eoc.patient.avatarId]" />
          </div>
        </div>
        <div
          class="mt-2 client-text-data d-flex flex-column justify-content-between"
        >
          <div>
            <p class="text-break mb-0 client-data">
              <span class="color-custom-dark-grey">Name: </span
              >{{ eoc.patient | formatClient }}
            </p>
            <p class="text-break mb-0 mt-1 client-data">
              <span class="color-custom-dark-grey">DOB: </span>
              {{ eoc.patient.dateOfBirth | formatDateOnly }}
            </p>
          </div>
          <div class="client-eoc-data">
            <div>
              <p class="text-break mb-0 mt-1 client-data text-nowrap">
                <span class="color-custom-dark-grey">MR#: </span>

                {{ { mrn: eoc.patient.mrn, eocn: eoc.eocn } | formatMrn }}
              </p>
              <p
                v-if="eoc.status != 'Inactive' && eoc.levelOfCare"
                class="text-break mb-0 mt-1 client-level"
                :style="`-webkit-line-clamp:${1}`"
              >
                <span class="color-custom-dark-grey">Current LOC: </span>
                <span :id="'eocIndexCardItem-Loc-value_' + eocIndex">{{
                  eoc.levelOfCare.name
                }}</span>
              </p>
              <p
                v-if="locations.length > 0 && selectedLocation == null"
                class="text-break mb-0 mt-1 client-data text-nowrap"
              >
                <span class="color-custom-dark-grey">Location: </span>
                {{ eoc.location ? eoc.location.name : "Not selected" }}
              </p>
              <p
                v-if="eoc.placesOfService.length > 0"
                class="text-break mb-0 mt-1 client-place"
                :style="
                  selectedLocation != null
                    ? `-webkit-line-clamp:${2}`
                    : `-webkit-line-clamp:${1}`
                "
              >
                <span class="color-custom-dark-grey">POS: </span>
                {{
                  eoc.placesOfService
                    ?.map(place => place.code + "-" + place.name)
                    .join(",")
                }}
              </p>
              <p class="text-break mb-0 mt-1 client-data text-nowrap">
                <span class="color-custom-dark-grey">Start/Adm Date: </span>
                <span :id="'eocIndexCardItem-StartDate-value_' + eocIndex">
                  {{ eoc.startDate | formatDateOnly }}
                </span>
              </p>
              <p
                v-if="eoc.status == 'Inactive'"
                class="text-break mb-0 mt-1 client-data text-nowrap"
              >
                <span class="color-custom-dark-grey">End Date: </span>
                <span :id="'eocIndexCardItem-EndDate-value_' + eocIndex">
                  {{ eoc.endDate | formatDateOnly }}
                </span>
              </p>
              <p
                v-if="eoc.status == 'Inactive' && eoc.dischargeReason"
                class="text-break mb-0 mt-1 client-data text-nowrap"
              >
                <span
                  :id="
                    'eocIndexCardItem-dischargeReason-value_' +
                      eocIndex +
                      '_' +
                      eoc.dischargeReason.name
                  "
                  class="color-custom-dark-grey"
                  >Reason:
                </span>
                {{
                  eoc.dischargeReason.name.toLowerCase() == "other"
                    ? eoc.otherDischargeReason
                    : eoc.dischargeReason.name
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="list.length < listTotal"
      class="d-flex justify-content-center mt-2"
    >
      <b-button
        id="eocs-grid-view-loadMore"
        @click="loadMoreEocs"
        variant="outline-secondary"
        style="padding: 10px 30px !important; border-radius:0px;"
        >Load more patients</b-button
      >
    </div>
    <report-request-index
      v-if="showReportRequestsModal"
      v-model="showReportRequestsModal"
      :reportFilters="exportFilter"
      reportName="Patients"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import EocView from "./EocView.vue";
import ReportRequestIndex from "../report_request/ReportRequestIndex.vue";

export default {
  name: "EocsGridView",
  components: { ReportRequestIndex },
  props: [
    "showing",
    "list",
    "listTotal",
    "exportFilter",
    "patientAvatars",
    "assignedToMeValue"
  ],
  data: () => ({
    refreshClients: [],
    refreshEocs: [],
    showReportRequestsModal: false
  }),
  mounted() {},
  methods: {
    getStatusBGClass(status) {
      switch (status) {
        case "Pending":
          return "bg-yellow";
        case "Active":
          return "bg-success";
        case "Inactive":
          return "bg-danger";
        default:
          return "";
      }
    },
    getStatusBorderClass(status) {
      switch (status) {
        case "Pending":
          return "border-yellow";
        case "Active":
          return "border-success";
        case "Inactive":
          return "border-danger";
        default:
          return "";
      }
    },
    viewClientEOC(eoc) {
      this.$emit("add-tab", {
        key: "eoc-" + eoc.id,
        text: this.formatEocObj(eoc),
        component: EocView,
        props: {
          eocId: eoc.id,
          clientId: eoc.patient.id
        },
        closeable: true
      });
    },
    loadMoreEocs() {
      this.$emit("load-more");
    },
    formatAlert(content) {
      return content.replace(/\n/g, "<br>");
    },
    changeAssignedToMEToggle() {
      this.assignedToMe = !this.assignedToMe;
    }
  },
  computed: {
    ...mapGetters("client", ["listeners"]),
    ...mapGetters("layout", ["hasCurrentUserReportPermission"]),
    ...mapState("layout", {
      currentUser: state => state.currentUser,
      selectedLocation: state => state.selectedLocation
    }),
    ...mapState("client", {
      locations: state =>
        state.locations.map(location => ({
          value: location.id,
          label: location.name
        }))
    }),
    assignedToMe: {
      get() {
        return this.assignedToMeValue;
      },
      set() {
        this.$emit("change-assignedToMe");
      }
    }
  }
};
</script>

<style scoped>
.filter-select {
  height: 50px;
  width: 300px;
  padding-top: 5px;
}
.search-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  min-width: 250px;
}
.client-card {
  min-width: 180px;
  max-width: 180px;
  height: 315px;
}
.little-circle {
  width: 10px;
  height: 10px;
}
.little-circle-exclamation {
  width: 20px;
  height: 20px;
}
.little-circle-exclamation-container {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}
.client-avatar {
  width: 100px;
  height: 100px;
  text-align: center;
}
.client-data {
  font-size: 0.8rem;
  word-break: break-all;
  overflow: hidden;
  text-overflow: clip;
}
.client-card:hover {
  cursor: pointer;
  box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.5);
  transform: translateY(-3px);
  transition-duration: 0.3s;
  transition-property: transform;
}
.clients-list {
  height: calc(100vh - 264px - var(--filter-height));
  overflow-y: auto;
}
.client-place {
  font-size: 0.8rem;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.client-level {
  font-size: 0.8rem;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.border-yellow {
  border-color: #ffc107 !important;
}
.bg-yellow {
  background-color: #ffc107 !important;
}
.client-text-data {
  height: 180px;
}
.client-eoc-data {
  height: 119px;
}
.filter-values {
  width: 250px;
}
.filter-value {
  position: relative;
  min-width: 100px;
  color: #a6a6a6;
  font-size: 14px;
}
.filter-value-delete {
  position: absolute;
  top: -8px;
  right: -8px;
}
.filter-value-delete:hover {
  cursor: pointer;
}
.clear-all-filters:hover {
  cursor: pointer;
}
.filter-values {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.filters-container {
  overflow-x: auto;
}
.separator-or {
  margin-bottom: -13px;
}
div.disabled {
  pointer-events: none;

  /* for "disabled" effect */
  opacity: 0.5;
  background: #ccc;
}
.max-2-lines {
  max-height: 38px;
}
.tooltip-icon-bg {
  top: 5px;
  left: 5px;
  width: 10px;
  height: 13px;
  z-index: 1;
}
</style>

<style>
.filter-select .vs__dropdown-toggle {
  height: 100%;
  border-radius: 0;
  border: 0;
}

.patient-badge {
  color: white;
  font-size: 11px;
  width: 40px;
  height: 16px;
  text-align: center;
  border-radius: 25px;
  line-height: 1.5;
}
.patient-picker-hide-options .vs__dropdown-menu {
  display: none;
}
.patient-picker-hide-options.vs--open .vs__dropdown-toggle {
  border-bottom-color: #4044e6 !important;
  border-bottom-width: 2px;
}
</style>
